export const CHECKBOX = {
  "Checkbox.Border.Color": {
    ref: "Color.Gray.400"
  },
  "Checkbox.Size": {
    defaultValue: "18px"
  },
  "Checkbox.Checkmark.Size": {
    defaultValue: "12px"
  },
  "Checkbox.Font.Size": {
    ref: "Input.Font.Size"
  },
  "Checkbox.Color": {
    ref: "Input.Color"
  },
  "Checkbox.Line.Height": {
    ref: "Input.Line.Height"
  },
  "Checkbox.Font.Weight": {
    ref: "Input.Font.Weight"
  },
  "Checkbox.Letter.Spacing": {
    ref: "Input.Letter.Spacing"
  },
  "Checkbox.Disabled.Text.Color": {
    ref: "Color.Text.Gray.100"
  },
  "Checkbox.Spacing": {
    ref: "Space.8"
  },
  "Checkbox.Selected.Bg.Color": {
    ref: "Color.Primary.500"
  },
  "Checkbox.Selected.Border.Color": {
    ref: "Color.Transparent"
  },
  "Checkbox.Selected.Checkmark.Color": {
    ref: "Color.Gray.600"
  },
  "Checkbox.Readonly.Bg.Color": {
    ref: "Color.Gray.200"
  },
  "Checkbox.Readonly.Border.Color": {
    ref: "Color.Transparent"
  },
  "Checkbox.Readonly.Checkmark.Color": {
    ref: "Color.Gray.600"
  }
};
